module.exports = __webpack_public_path__ + "static/media/ios.794f62d2.svg";